import { buildProps, definePropType } from '@sgui-plus/utils/props'
import type { ExtractPropTypes } from 'vue'

type ProgressFn = (percent: number) => string

export const progressProps = buildProps({
  percent: {
    type: Number,
    default: 0,
    validator: (val: number): boolean => val >= 0 && val <= 100,
  },
  status: {
    type: String,
    default: ''
  },
  strokeWidth: {
    type: Number,
    default: 6,
  },
  textInside: {
    type: Boolean,
    default: false,
  },
  hideInfo: {
    type: Boolean,
    default: false,
  },
  format: {
    type: definePropType<ProgressFn>(Function),
    default: (percent: number): string => `${percent}%`,
  },
  textColor: String,
  innerColor:String,
  noRound: {
    type: Boolean,
    default: false
  },
  indeterminate: {
    type: Boolean,
    default: false
  },
  duration: {
    type: Number,
    default: 3
  }
} as const)

export type ProgressProps = ExtractPropTypes<typeof progressProps>
